import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { changeCommandStatus } from "../../mutations/command.mutations";
import UpdateOrderStatusForm from "../forms/UpdateOrderStatusForm";
import PenIcon from "../icons/PenIcon";

type UpdateOrderModalProps = {
	orderId: number;
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function UpdateOrderModal({
	orderId,
	isOpen,
	onOpen: _,
	onClose,
}: UpdateOrderModalProps) {
	const { mutate: mutateCommandStatus } = useMutation(changeCommandStatus);
	const queryClient = useQueryClient();
	const handleSubmit = useCallback(
		(data: { status: string; explanation: string; reason: string }) => {
			mutateCommandStatus(
				{
					id: orderId,
					reason: data.reason,
					status: data.status,
					explanation: data.explanation,
				},
				{
					onSettled: () => {
						queryClient.invalidateQueries(["command"]);
						onClose();
					},
				},
			);
		},
		[orderId, mutateCommandStatus, onClose],
	);
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor="brand.100"
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							<PenIcon w="24px" h="24px" color="brand.700"></PenIcon>
						</Flex>
						<Box lineHeight="48px">Modifier la commande</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody>
					<UpdateOrderStatusForm
						id={orderId}
						onClose={onClose}
						onSubmit={handleSubmit}
					></UpdateOrderStatusForm>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default UpdateOrderModal;
